import { render, staticRenderFns } from "./VCardContent.vue?vue&type=template&id=334c01aa&lang=pug&functional=true&"
import script from "./VCardContent.vue?vue&type=script&lang=js&"
export * from "./VCardContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports